import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen font-sans text-slate-800 bg-slate-50 selection:bg-[#1a365d] selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProofBar data-id="element-3" />
      <TomosSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}